import React from 'react';
import PropTypes from 'prop-types';

import PersonImg from 'inside-out/images/medicare/person-1.png';

import {
	innerWrapperStyle,
	wrapperStyle,
	titleStyle,
	textStyle,
  resourceWrapper,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';

import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard'

const MedicareForHealthProfessionalsStep2Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
          <h1 className={titleStyle}>Commence Initial Course of Treatment</h1>
          <div className={textStyle}>
            <p>(Psychological & dietetic services)</p>

            <p>Once a patient has an EDP in place, the 12 month period commences. The patient can then access an initial course of 10 rebatable psychological sessions with an eligible mental health provider.  They can also access 20 dietetic sessions which they can either space across the 12 months or use more intensively in a shorter timeframe - this is a matter for the patient and their team to decide.  The remaining 30 psychological sessions can be approved by the GP in 10 session increments for those that require longer term therapy. A A psychiatrist or paediatrician review is required to open access to sessions 21-40.</p>

            <p>We encourage the GP to refer the patient to a psychiatrist or paediatrician (as relevant) early in the course of the EDP if it is thought that a patient will require more than 20 sessions, so that the specialist review can occur in a timely manner and not interrupt psychological treatment.</p>
          </div>
      </div>
    </section>

    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
          <h1 className={titleStyle}>Returning to the GP</h1>
          <div className={textStyle}>
            <p>Before the patient can receive the second group of 10 psychological treatment sessions they will need to return to the GP for a review and ongoing referral.</p>
            <p>It is required that the dietitian provide a letter to the GP following the initial assessment (after sessions 1 to 2) and recommended that the mental health provider do the same along with the required review at or before Session 10. Template letters are provided below. We encourage providers where possible and appropriate to send copies to other professionals involved in the patients' care. We particularly suggest that mental health providers and dietitians are aware of the requirements of the specialist report and support the psychiatrist/paediatrician with this process by including any relevant information in their correspondance.  A factsheet on the specialist report can be found below.</p>
          </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle} style={{display: 'flex' }}>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/psychological-treatment-initial-report-template' }
            audiences={ [] }
            title={ 'Psychological Treatment Initial Report Template' }
            body={ 'The psychological treatment provider can use this template for a report back to the medical practitioner following initial 1-2 sessions' }
            date={ '1 Nov, 2019' }
          />
        </div>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/dietetic-treatment-initial-report-template' }
            audiences={ [] }
            title={ 'Letter from Dietitian Session 1 or 2' }
            body={ 'The dietitian can use this template for a report back to the medical practitioner following initial 1-2 sessions' }
            date={ '1 Nov, 2019' }
          />
        </div>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/psychological-treatment-review-template' }
            audiences={ [] }
            title={ 'Letter from Psych prior to Session 10' }
            body={ 'The psychological treatment provider can use this template for a report back to the medical practitioner prior to care plan reviews at or before session 10, 20 and 30' }
            date={ '1 Nov, 2019' }
          />
        </div>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/the-specialist-review' }
            audiences={ [] }
            title={ 'The Specialist Review' }
            body={ 'Summary of the formal specialist review by a consultant paediatrician or a consultant psychiatrist required to continue beyond 20 EDPT services.' }
            date={ '1 Nov, 2019' }
          />
        </div>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/gp-care-plan-review-template' }
            audiences={ [] }
            title={ 'GP Care Plan Review Template' }
            body={ 'The medical practitioner can use this template to complete the Eating Disorder Care Plan Review at session 10, 20 and 30.' }
            date={ '1 Nov, 2019' }
          />
        </div>
      </div>
    </section>
  </div>
);

export { MedicareForHealthProfessionalsStep2Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-health-professionals/step-2.js